import { createSlice } from '@reduxjs/toolkit'

import { MessagesState } from './messages.type'

const initialState: MessagesState = {
  loading: false,
  isOpenTabMessage: false,
}

const messagesSlice = createSlice({
  name: 'messages',
  initialState,
  reducers: {
    setIsOpenTabMessage: (state, action) => {
      state.isOpenTabMessage = action.payload
    },
    setLoading: (state, action) => {
      state.loading = action.payload
    },
  },
  extraReducers: () => {},
})

export const messagesActions = messagesSlice.actions
const messagesReducer = messagesSlice.reducer
export default messagesReducer
